export const fieldMap: { [key: string]: string } = {
  centralBankFacility: "CBF",
  wsf1: "1 Year",
  wsf2: "2 Year",
  wsf3: "3 Year",
  wsf4: "4 Year",
  wsf5: "5 Year",
};
